// The Disclosure Information section's labels, messages and rules (Feature 8459, stories 11029-11033).
import { endOfAlbertaToday } from "../../../utils/albertaTime";
import { toCalendarDay } from "../../../utils/calendarDay";
import { INVALID_DATE_FORMAT_MESSAGE, isYes } from "./pageFields";

export const PERMISSION_LABEL = "Permission to order disclosure?";
export const ORDERED_LABEL = "Disclosure has been ordered?";
export const UPLOADED_LABEL = "Disclosure Uploaded?";
export const PERMISSION_PLACEHOLDER = "Permission to order disclosure";
export const ORDERED_PLACEHOLDER = "Disclosure has been ordered";
export const UPLOADED_PLACEHOLDER = "Disclosure Uploaded";
export const ORDER_DATE_LABEL = "Disclosure Order Date";
export const UPLOAD_DATE_LABEL = "Disclosure Upload Date";
export const DISCLOSURE_STATUS_LABEL = "Disclosure Status";
export const PACKAGE_REQUEST_LABEL = "Disclosure Package Request";
export const OTHER_EXPLANATION_LABEL = "Please specify";
// The placeholder is the label, as on the page's other fields; the story names the field "Please specify"
export const OTHER_EXPLANATION_PLACEHOLDER = OTHER_EXPLANATION_LABEL;
// "Other" is known by its id, as the API knows it: labels are rows in Statuses and may be reworded, the id may not
export const OTHER_DISCLOSURE_STATUS_ID = 20;

// "<label> is Required" is the acceptance-criteria wording for the dates and the two choices; the questions keep the
// page's usual REQUIRED_FIELD_MESSAGE, so the two wordings in one section are intended
export const requiredMessage = (label) => `${label} is Required`;
export const futureMessage = (label) => `${label} cannot be in the future`;
export const OTHER_EXPLANATION_REQUIRED_MESSAGE = "Please specify the other Disclosure Status";

// The longest explanation the column takes; the field stops there
export const OTHER_EXPLANATION_MAX_LENGTH = 256;

export const isOther = (disclosureStatus) => disclosureStatus?.id === OTHER_DISCLOSURE_STATUS_ID;
export const isBlank = (text) => typeof text !== 'string' || text.trim() === '';
// The option the select names, or null while the select is blank. The two selects offer exactly the stories' options,
// so blank is only ever the default: once a value is chosen there is no choice that takes it away.
export const choiceNamed = (choices, label) => choices.find((choice) => choice.label === label) ?? null;

const isUnreadableDate = (date) => Number.isNaN(date.getTime());

// Why a Disclosure date cannot be saved, or null when it can: unreadable, or after today. Any past day is allowed,
// as the stories say (a user may record late the day disclosure was ordered a second time). The API applies the same
// two rules; this is the same wording so the field and the toast agree.
export const disclosureDateProblem = (label, date) => {
    const parsed = new Date(date);
    if (isUnreadableDate(parsed)) return INVALID_DATE_FORMAT_MESSAGE;
    if (parsed > endOfAlbertaToday()) return futureMessage(label);
    return null;
};

// A typed or picked date is kept as entered so the user can see and fix it; an unreadable one stays as typed
export const enteredDate = (date) => {
    const parsed = new Date(date);
    return isUnreadableDate(parsed) ? date : parsed;
};

// Legacy-layout interactions send their stored dates back untouched; on the new layout a date only travels with a Yes.
// A date is a calendar day and travels as one (see toCalendarDay), so the day the user sees is the day stored,
// whatever zone the browser is in. An unreadable date never travels.
export const disclosureDateToSave = (date, question, showDisclosureInformation) => {
    if (showDisclosureInformation && !isYes(question)) return null;
    return toCalendarDay(date);
};
